import {PromptModel} from "../../models/prompt";
import React from "react";
import {useAppSelector} from "../../app/hooks";
import {selectIsLoading} from "../../redux/prompt/promptListSlice";
import {ColumnProps} from "rc-table/lib/sugar/Column";
import {Caption, Heading4, Paragraph} from "../text";
import Moment from "moment";
import Table from "rc-table";
import {Button} from "../buttons/Button";
import Link from 'next/link'
import {useModalRouting} from "../../utils/useModalRouting";

export interface PromptsTableProps {
  prompts: PromptModel[]
  onLoadMoreClicked: () => void
}

const TableHeader: React.FC<{ isFirst?: boolean, isLast?: boolean }> = ({ isFirst, children, isLast }) => {
  return <div className={`py-3 px-4 whitespace-nowrap flex items-center bg-fg-gray-surface-light h-12 ${isFirst ? 'rounded-tl-lg' : isLast ? 'rounded-tr-lg' : ''}`}>
    {children}
  </div>
}

const TableCell: React.FC<any> = ({ children }) => {
  return <div className={`py-3 px-4 whitespace-nowrap border-t border-fg-gray-surface h-16 flex items-center`}>
    {children}
  </div>
}

export const PromptTable: React.FC<PromptsTableProps> = ({ prompts, onLoadMoreClicked }) => {
  const isLoading = useAppSelector(selectIsLoading)
  const { createRoute } = useModalRouting()

  const columns: ColumnProps<PromptModel>[] = [
    {
      title: <TableHeader isFirst={true}>
        <Heading4 className="text-fg-gray-dark">Title</Heading4>
      </TableHeader>,
      dataIndex: 'title',
      render: (text, record) => (
        <TableCell>
          <div>
            <Paragraph>{`${record.name}`}</Paragraph>
            <Caption className="text-fg-gray-dark">Title: {`${record.title}`}</Caption>
          </div>
        </TableCell>
      )
    },
    {
      title: <TableHeader>
        <Heading4 className="text-fg-gray-dark">Create On</Heading4>
      </TableHeader>,
      dataIndex: 'created_at',
      render: (text, record) => (
        <TableCell>
          <Paragraph>{Moment(record.createdAt).format('MMM D, YYYY')}</Paragraph>
        </TableCell>
      )
    },
    {
      title: <TableHeader isLast={true}>

      </TableHeader>,
      dataIndex: 'action',
      render: (text, record) => (
        <TableCell>
          <Link href={createRoute({ name: 'prompt_detail', query: { prompt_id: record.promptId }, returnTo: '/admin/prompts' })}
                shallow={true}
                passHref
          >
            <a>
              <Button>Edit</Button>
            </a>
          </Link>
        </TableCell>
      )
    }
  ]

  return <Table
    className="rounded-lg border border-fg-gray-surface fg-table"
    scroll={{x: true}}
    data={prompts}
    columns={columns}
    emptyText={() => {
      return <div className="w-full h-16 flex items-center justify-center">
        <Paragraph>No Prompts</Paragraph>
      </div>
    }}
    footer={() => {
      return <div className="w-full flex items-center justify-center py-8 border-t border-fg-gray-surface">
        <Button
          buttonStyle="secondary"
          isLoading={isLoading}
          onClick={() => {
            onLoadMoreClicked()
          }}
        >
          Load More
        </Button>
      </div>
    }}
  />
}